const mobileRegex =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

const androidRegex = /Android/i;

const iOSRegex = /iPhone|iPad|iPod/i;

/**
 * @description 桌機殼注入的橋接物件。preload 在頁面腳本執行前就掛上 window.api，
 * 所以在 module 求值階段讀得到，`isWeb` 維持「載入時算一次」的既有語意。
 * 型別上 window.api 宣告為必存在（給 47 個呼叫點用），這裡刻意當成可能不存在來讀。
 */
const desktopBridge = (window as Window & { api?: Window['api'] }).api;

const hasDesktopBridge =
  typeof desktopBridge?.on === 'function' &&
  typeof desktopBridge?.send === 'function' &&
  typeof desktopBridge?.invoke === 'function';

/**
 * @description 是否為網頁版（沒有桌機功能）。
 *
 * 不能用 User-Agent 判斷：南一會員中心首頁的產品格是 window.open 開新視窗，
 * Electron 為它建立的視窗不繼承主視窗的 preload，UA 仍含 `electron/` 但
 * window.api 不存在，所有 `if (!isWeb)` 分支都會撞上 undefined 而整頁崩潰
 * （Sentry NANI-BOX3-22 / 21 / 1Y）。直接確認橋接在不在才是不會說謊的訊號。
 */
export const isWeb = !hasDesktopBridge;

/**
 * @description UA 自稱 Electron、桌機橋接卻不存在——即上述壞掉的視窗。
 * 只給診斷回報用，不參與任何功能分流。
 */
export const isBridgeMissingInElectron =
  /electron\//i.test(navigator.userAgent) && !hasDesktopBridge;

export const isMobileDevice = mobileRegex.test(navigator.userAgent);

export const isAndroid = androidRegex.test(navigator.userAgent);

export const isiOS = iOSRegex.test(navigator.userAgent);

export const isWindows = navigator.userAgent.includes('Windows');

export const isMac = navigator.userAgent.includes('Mac');
